module.exports = __webpack_public_path__ + "img/terroir-1-mobile.4f602144.jpg";